module.exports = __webpack_public_path__ + "img/Kekeluargaan-logo.502a4cb8.png";